import React from 'react';
import './CircularLoader.css'; // Import the CSS file for styling

const CircularLoader = () => {
  return <div className="circular-loader"></div>;
};

export default CircularLoader;
